import { PLP_END_POINT_CLIENT } from "@/constants"
import { aemAxiosInstance, apim } from "@/constants/api"
import qs from "qs"
import { getConfig } from "@/constants/config"
import { getSessionIdObjWithEpoc } from "@/utils/ApiUtil"
import { getUserPersona, getAccessToken, isCanadaSite } from "@/utils/helper"
import { addCollectionParam, formatListingData } from "@/utils/product"
import {
  getPlpProcessedData,
  getFacetFieldWithLabel,
} from "@/responseProcessors/plpResponseProcessor"

export const getListFromClient = async (
  profileName,
  params,
  isServiceParts,
  plpServletPath
) => {
  const config = await getConfig()
  const language = config?.internationalization?.language ?? "en"
  const canadianPrice = config?.apiEndPointData?.map?.canadianPrice ?? null
  const isCanadaCheck = isCanadaSite(config?.general?.siteName)
  const {
    general: {
      serviceParts = "",
      siteName = "",
      disableCommerce,
      swatchUrl,
    } = {},
    general,
    presetConfigs: { plp: plpPresetConfig = {} } = {},
    plpConfigurations: { myArrayList: plpBadgeList = [] } = {},
  } = config
  const collections = isServiceParts ? serviceParts : ""
  const persona = getUserPersona()
  const accessToken = getAccessToken()?.token

  const plpRequestParams = {
    ...params,
    sort:
      getFacetFieldWithLabel(params?.sort, persona, isCanadaCheck) ??
      params.sort?.replace(/\+/g, " "),
    sessionId: getSessionIdObjWithEpoc(),
  }

  const configParams = {
    configdata: {
      plpBadgeList,
      disableCommerce,
      canadianPrice,
    },
    swatchUrl,
    plpServletPath,
    general,
  }

  if (collections) plpRequestParams.collections = collections
  if (canadianPrice) plpRequestParams.CanadianPrice = canadianPrice
  if (
    typeof plpRequestParams.sort === "string" &&
    plpRequestParams.sort === ""
  ) {
    delete plpRequestParams.sort
  }
  if (!plpRequestParams.fq) {
    plpRequestParams.fq = `language_s:${language}`
  }
  if (
    typeof plpRequestParams.fq === "string" &&
    plpRequestParams.fq.length > 0
  ) {
    plpRequestParams.fq = [plpRequestParams.fq, `language_s:${language}`]
  } else if (Array.isArray(plpRequestParams.fq)) {
    plpRequestParams.fq = [...plpRequestParams.fq, `language_s:${language}`]
  }

  const url = addCollectionParam(
    `${PLP_END_POINT_CLIENT}?profilename=${profileName}&persona=${persona}`,
    siteName
  )
  aemAxiosInstance.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${accessToken}`
  try {
    const response = await apim.get(url, {
      params: plpRequestParams,
      paramsSerializer: params => {
        return qs.stringify(params, {
          arrayFormat: "repeat",
          encode: false,
        })
      },
    })
    const formattedData = await formatListingData(response?.data, false)
    const plpData = await getPlpProcessedData(
      formattedData,
      false,
      [],
      "",
      configParams,
      plpPresetConfig
    )
    return plpData
  } catch (error) {
    throw new Error(error)
  }
}
